<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore';
import api from '@/services/axios'

const userStore = useUserStore()

const router = useRouter()
const username = ref('')
const password = ref('')
const error = ref('')

const login = async () => {
  try {
    const response = await api.post('/auth/login', {
      username: username.value,
      password: password.value
    });

    const data = response.data;
    localStorage.setItem('editortoken', data.token);
    await userStore.loadUserOnInit();
    router.push('/home');
  } catch (err) {
    console.error("Login error:", err);
    console.error("Backend response:", err?.response?.data);
    error.value = err?.response?.data?.error || 'An error occurred';
  }
}
</script>

<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <img class="logoGate" width="150px" src="../assets/WASPL_anim.gif" alt="Logo animé WASPL" />
            <h2 class="card-title text-center mb-4">Editor Access Control</h2>
            <form @submit.prevent="login">
              <div class="mb-3">
                <label for="username" class="form-label">Username</label>
                <input type="text" class="form-control" id="username" v-model="username" required>
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <input type="password" class="form-control" id="password" v-model="password" required>
              </div>
              <div v-if="error" class="alert alert-danger">
                {{ error }}
              </div>
              <button type="submit" class="btn btn-primary w-100">
                Sign In
              </button>
              <div class="text-center mt-3">
                <router-link to="/register">Not registered yet? Create an account</router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.logoGate {
  margin:auto;
  display: block;
  margin: 0 auto;
}

.card-title{
  color:#0B688C
}
</style>